import React from "react";

import ImgCardRender from "./ImgCardRender/ImgCardRender";

const Provinces = () => {
  return (
    <>
      <ImgCardRender />
    </>
  );
};

export default Provinces;
